export const generateLawnCareReviewsPageOpenGraphTags = async ({
  request,
  fetch,
}) => {
  return [
    { property: 'og:title', content: 'Sunday Lawn Care Reviews' },
    {
      property: 'og:description',
      content:
        'Read verified Sunday Lawn Care reviews and see how real customers are transforming their lawns with easy, custom lawn care.',
    },
    { property: 'og:type', content: 'website' },
    {
      property: 'og:image',
      content:
        'https://www.getsunday.com/images/open-graph/sunday-lawn-care-reviews.jpg',
    },
    { property: 'og:image:width', content: '1200' },
    { property: 'og:image:height', content: '630' },
    { property: 'og:url', content: 'https://www.getsunday.com' + request.url },
  ];
};

export const generateCustomLawnPlanPageOpenGraphTags = async ({
  request,
  fetch,
}) => {
  return [
    { property: 'og:title', content: 'Sunday Custom Lawn Care Plan' },
    {
      property: 'og:description',
      content:
        "A custom lawn plan from Sunday is the easiest way to maintain a happy and healthy lawn. We'll send you the right nutrients for your lawn, with personalized instructions.",
    },
    { property: 'og:type', content: 'website' },
    {
      property: 'og:image',
      content:
        'https://www.getsunday.com/images/open-graph/custom-lawn-plan.jpg',
    },
    { property: 'og:image:width', content: '1200' },
    { property: 'og:image:height', content: '630' },
    { property: 'og:url', content: 'https://www.getsunday.com' + request.url },
  ];
};

export const generateCustomPestPlanPageOpenGraphTags = async ({
  request,
  fetch,
}) => {
  return [
    { property: 'og:title', content: 'Sunday Preventive Pest Control' },
    {
      property: 'og:description',
      content:
        'Protect your home from dozens of pests using feel-good ingredients! Sunday pest protection is tailored for where you live and simple to use. We can quickly customize a plan for your home today!',
    },
    { property: 'og:type', content: 'website' },
    {
      property: 'og:image',
      content:
        'https://www.getsunday.com/images/open-graph/custom-pest-plan.jpg',
    },
    { property: 'og:image:width', content: '1200' },
    { property: 'og:image:height', content: '630' },
    { property: 'og:url', content: 'https://www.getsunday.com' + request.url },
  ];
};

export const generateAboutUsPageOpenGraphTags = async ({ request, fetch }) => {
  return [
    { property: 'og:title', content: 'About Sunday Custom Yard Care' },
    {
      property: 'og:description',
      content:
        "Sunday is a new kind of lawn care that's safe for you family. Using plant science and modern technology we can help you create a beautiful lawn without all the nasty pesticides.",
    },
    { property: 'og:type', content: 'website' },
    {
      property: 'og:image',
      content:
        'https://www.getsunday.com/images/open-graph/custom-lawn-plan.jpg',
    },
    { property: 'og:image:width', content: '1200' },
    { property: 'og:image:height', content: '630' },
    { property: 'og:url', content: 'https://www.getsunday.com' + request.url },
  ];
};
